import { ArrowDropDown, Print } from "@mui/icons-material";
import {
  Button,
  ButtonGroup,
  ClickAwayListener,
  Grow,
  MenuItem,
  MenuList,
  Paper,
  Popper,
  styled,
} from "@mui/material";
import React, { useEffect } from "react";

const MenuButtonIcon = styled(Button)((theme) => ({
  padding: "0 !important",
  minWidth: "25px !important",
  "& svg": {
    margin: "0 !important",
  },
}));

const buttonOptions = ["Print A4","Print"];

const ButtonDropDown = (props) => {

  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef(null);
  const [selectedIndex, setSelectedIndex] = React.useState(0);
  
  const handleClick = () => {
    // console.info(`You clicked ${buttonOptions[selectedIndex]}`);
    props.handleClickPrint(buttonOptions[selectedIndex], props.row);
  };

  const handleMenuItemClick = (event, index) => {
    setSelectedIndex(index);

    props.handleClickPrint(buttonOptions[index], props.row);

    setOpen(false);
  };

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }

    setOpen(false);
  };

  return (
    <div>
      <ButtonGroup
        variant="contained"
        ref={anchorRef}
        aria-label="split button"
      >
        <Button sx={{ width: "140px" }} onClick={handleClick}>
          {props.checkedValues ? (
            <>
              <Print style={{ marginRight: "5px" }} fontSize="small" />
              {buttonOptions[selectedIndex] + "(" + props.checkedValues + ")"}
            </>
          ) : (
            buttonOptions[selectedIndex]
          )}
        </Button>
        <MenuButtonIcon
          // size="small"
          aria-controls={open ? "split-button-menu" : undefined}
          aria-expanded={open ? "true" : undefined}
          aria-label="select merge strategy"
          aria-haspopup="menu"
          onClick={handleToggle}
        >
          <ArrowDropDown fontSize="small" />
        </MenuButtonIcon>
      </ButtonGroup>
      <Popper
        sx={{
          zIndex: 1,
        }}
        open={open}
        anchorEl={anchorRef.current}
        role={undefined}
        transition
        disablePortal
      >
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin:
                placement === "bottom" ? "center top" : "center bottom",
            }}
          >
            <Paper>
              <ClickAwayListener onClickAway={handleClose}>
                <MenuList id="split-button-menu" autoFocusItem>
                  {buttonOptions.map((option, index) => (
                    <MenuItem
                      key={option}
                      selected={index === selectedIndex}
                      onClick={(event) => handleMenuItemClick(event, index)}
                    >
                      {option}
                    </MenuItem>
                  ))}
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </div>
  );
};

export default ButtonDropDown;
